import React from 'react'
import BrowserRouter from "./routes"
//var cors = require('cors')
// import Header from './Header';
// import Menu from './Menu';
// import Footer from './Footer';
// import Content from './Content';

 
const App = () => <BrowserRouter />;
//App.use(cors())

export default App;


// export default class App extends Component {
//   render() {
//     return (
//       <div>
//       <Header />
//       <Menu/>
//       <Content/>
//       <Footer/>
//       </div>
//     )
//   }
// }
